import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {

    constructor(
        private readonly snackBar: MatSnackBar
    ) {
    }

    openErrorSnackBar(message: string, duration: number = 5000): void {
        this.snackBar.open(message, 'Dismiss', {
            duration,
            panelClass: 'snackbar-error'
        });
    }

    openSuccessSnackBar(message: string, duration: number = 5000): void {
        this.snackBar.open(message, 'Dismiss', {
            duration,
            panelClass: 'snackbar-success'
        });
    }
}
